import React from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  CardContent,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";

import EditDelete from "../../../../components/EditDelete";
import Toolbar from "../../../../components/Toolbar";
import useWindowDimensions from "../../../../utils/windowDimensions";
import useVillage from "../../../../hooks/useVillage";
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Masters</Typography>
      <Typography>Village</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

const CustomDataGrid = (props) => {
  const { isLoadingDownload, downloadFileType } = useVillage();

  const { height, width } = useWindowDimensions();
  const {
    editPage,
    addPage,
    trans,
    data,
    rowCount,
    paging,
    onPageChange,
    isLoading,
    id,
    handleSortModelChange,
    sortModel,
    downloadFile,
    openDownloadDialog,
    refreshPage,
  } = props;
  console.log(rowCount, "loading child component");

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
        };
        return (
          <EditDelete rowClick={onClick} editPage={() => editPage(params.id)} menus={["edit"]} />
        );
      },
    },
    {
      field: "villageName",
      headerName: "Village Name",
      width: 300,
    },
    {
      field: "cityName",
      headerName: "City Name",
      valueGetter: (params) => params.row.city?.cityName,
      type: "string",
      width: 300,
    },
    {
      field: "talukName",
      headerName: "Taluk Name",
      valueGetter: (params) => params.row.city?.taluk?.talukName,
      type: "string",
      width: 300,
    },
    {
      field: "districtName",
      headerName: "District Name",
      valueGetter: (params) => params.row.city?.taluk?.district?.districtName,
      type: "string",
      width: 300,
    },
    {
      field: "state",
      headerName: "State Name",
      valueGetter: (params) => params.row.city?.taluk?.district?.state?.stateName,
      type: "string",
      width: 300,
    },
    {
      field: "country",
      headerName: "Country Name",
      valueGetter: (params) => params.row.city?.taluk?.district?.state?.country?.countryName,
      type: "string",
      width: 300,
    },
    {
      field: "pincode",
      headerName: "Pincode",
      valueGetter: (params) => params.row.pincode?.pincodeName,
      type: "string",
      width: 300,
    },
  ];
  //setRowsState((prev) => ({ ...prev, page }))
  //setRowsState((prev) => ({ ...prev, pageSize }))

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <Toolbar
            addPage={addPage}
            downloadFile={downloadFile}
            openDownloadDialog={openDownloadDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            refreshPage={refreshPage}
          />
        }
        title={trans("village_list")}
        subheader={breadCrump()}
      />
      <CardContent sx={{ height: height - 180 }}>
        <DataGrid
          columns={columns}
          rows={data}
          rowCount={rowCount}
          getRowId={(row) => row[id]}
          loading={isLoading}
          rowsPerPageOptions={[5]}
          pagination
          page={paging.pageNumber}
          pageSize={paging.pageSize}
          paginationMode="server"
          onPageChange={(page) => onPageChange(page)}
          onPageSizeChange={(pageSize) => onPageChange(pageSize)}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
        />
      </CardContent>
    </Card>
  );
};
export default CustomDataGrid;
